import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V = {
  '@id': string;
  '@type': 'ClientClassification';
  id: string;
  name: string;
  description: string | null;
};

export type W = {
  name: string;
  description: string | null;
};

export function useReadCollection(
  queryParams?: { name?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V>>(
    `/client-classifications${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/client-classifications/${id}`, options);
}
